import { isEqual } from 'underscore';
import React, { useCallback, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withCustomValidation } from '@bingads-webui-react/validation';
import { GoalSelector } from '@bingads-webui-campaign-react/goal-selector-v3';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { getConversionGoalStyles } from './validated-conversion-goals';

const ConversionGoalsWithCustomValidation = ({
  validationProps, updateValidation, cid, aid, ...restProps
}) => {
  const { data: conversionGoalsData } = validationProps;
  const { conversionGoals = {} } = conversionGoalsData;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getConversionGoalStyles);

  const activity = useContext(ActivityContext);

  const onChange = useCallback((changedData) => {
    const newData = {
      conversionGoals: {
        ...conversionGoalsData.conversionGoals,
        ...changedData,
      },
    };

    updateValidation([], isEqual(newData, conversionGoalsData) ? conversionGoalsData : newData);

    if (activity) {
      activity.signal(`onConversionGoalsChange - ${JSON.stringify(newData)}`);
    }
  }, [conversionGoalsData, updateValidation, activity]);

  const campaignConversionGoal = useMemo(() => ({
    Goals: conversionGoals.originalConversionGoals,
  }), [conversionGoals.originalConversionGoals]);

  return (conversionGoals && conversionGoals.goalScopeSelection ?
    <div className={classes.ConversionGoalSelectorContainer}>
      <GoalSelector
        {...restProps}
        i18n={i18n}
        cid={cid}
        aid={aid}
        open={open}
        value={conversionGoals.goalSelection}
        campaignConversionGoal={campaignConversionGoal}
        goalScopeSelection={conversionGoals.goalScopeSelection}
        onChange={onChange}
        activityLogger={activity}
      />
    </div> : null
  );
};

ConversionGoalsWithCustomValidation.propTypes = {
  validationProps: PropTypes.shape({
    data: PropTypes.shape({
      conversionGoals: PropTypes.shape({
        goalSelection: PropTypes.arrayOf(PropTypes.shape({})),
        goalScopeSelection: PropTypes.string,
        originalConversionGoals: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    }),
  }).isRequired,
  updateValidation: PropTypes.func.isRequired,
  isCreationWorkflow: PropTypes.bool,
  cid: PropTypes.number.isRequired,
  aid: PropTypes.number.isRequired,
};

ConversionGoalsWithCustomValidation.defaultProps = {
  isCreationWorkflow: false,
};

export const ValidatedConversionGoalsScopeSelector = withCustomValidation(ConversionGoalsWithCustomValidation);
